<template>
  <div v-if="isSelected" class="col-12">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'Tab',
    props: {
      isSelected: {
        type: Boolean,
      },
    },
  }
</script>
